











































































































































































import _get from 'lodash/get'
import { Component, Vue } from 'vue-property-decorator'

import ElsaButton from '@/components/button/button.vue'
import ErikoistuvaDetails from '@/components/erikoistuva-details/erikoistuva-details.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import KoejaksonVaiheHyvaksynnat from '@/components/koejakson-vaiheet/koejakson-vaihe-hyvaksynnat.vue'
import KoulutuspaikanArvioijat from '@/components/koejakson-vaiheet/koulutuspaikan-arvioijat.vue'
import ElsaConfirmationModal from '@/components/modal/confirmation-modal.vue'
import ElsaFormMultiselect from '@/components/multiselect/multiselect.vue'
import store from '@/store'
import {
  ValiarviointiLomake,
  Koejakso,
  KoejaksonVaiheHyvaksynta,
  KoejaksonVaiheHyvaksyja,
  KoejaksonVaiheButtonStates
} from '@/types'
import { KehittamistoimenpideKategoria, LomakeTilat } from '@/utils/constants'
import { formatSaveError } from '@/utils/errorMessage'
import * as hyvaksynnatHelper from '@/utils/koejaksonVaiheHyvaksyntaMapper'
import { toastFail, toastSuccess } from '@/utils/toast'

@Component({
  components: {
    ErikoistuvaDetails,
    ElsaFormGroup,
    ElsaFormMultiselect,
    ElsaButton,
    ElsaConfirmationModal,
    KoulutuspaikanArvioijat,
    KoejaksonVaiheHyvaksynnat
  }
})
export default class ErikoistuvaArviointilomakeValiarviointi extends Vue {
  $refs!: {
    koulutuspaikanArvioijat: KoulutuspaikanArvioijat
  }
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('koejakso'),
      to: { name: 'koejakso' }
    },
    {
      text: this.$t('koejakson-valiarviointi'),
      active: true
    }
  ]

  loading = true

  buttonStates: KoejaksonVaiheButtonStates = {
    primaryButtonLoading: false,
    secondaryButtonLoading: false
  }

  koejaksonVaihe = this.$t('valiarviointi')

  valiarviointiLomake: Partial<ValiarviointiLomake> = {
    edistyminenTavoitteidenMukaista: null,
    erikoistuvanErikoisala: this.account.erikoistuvaLaakari.erikoisalaNimi,
    erikoistuvanNimi: `${this.account.firstName} ${this.account.lastName}`,
    erikoistuvanOpiskelijatunnus: this.account.erikoistuvaLaakari.opiskelijatunnus,
    erikoistuvanYliopisto: this.account.erikoistuvaLaakari.yliopisto,
    id: null,
    kehittamistoimenpideKategoriat: [],
    kehittamistoimenpiteet: '',
    korjausehdotus: '',
    lahiesimies: {
      id: null,
      kayttajaUserId: null,
      kuittausaika: '',
      nimi: '',
      nimike: null,
      sopimusHyvaksytty: false
    },
    lahikouluttaja: {
      id: 0,
      kayttajaUserId: null,
      kuittausaika: '',
      nimi: '',
      nimike: null,
      sopimusHyvaksytty: false
    },
    muokkauspaiva: '',
    muuKategoria: '',
    vahvuudet: ''
  }

  kategoriaOrder = [
    KehittamistoimenpideKategoria.TYOSSASUORIUTUMINEN,
    KehittamistoimenpideKategoria.TYOKAYTTAYTYMINEN,
    KehittamistoimenpideKategoria.POTILASPALAUTE,
    KehittamistoimenpideKategoria.MUU
  ]

  validateState(value: string) {
    const form = this.$v.valiarviointiLomake
    const { $dirty, $error } = _get(form, value) as any
    return $dirty ? ($error ? false : null) : null
  }

  get account() {
    return store.getters['auth/account']
  }

  get kouluttajat() {
    return store.getters['erikoistuva/kouluttajatJaVastuuhenkilot'] || []
  }

  get editable() {
    if (this.account.impersonated) {
      return false
    }
    return this.koejaksoData.valiarvioinninTila === LomakeTilat.UUSI
  }

  get deletable() {
    return this.koejaksoData.valiarvioinninTila === LomakeTilat.ODOTTAA_HYVAKSYNTAA
  }

  get showWaitingForAcceptance() {
    return this.koejaksoData.valiarvioinninTila === LomakeTilat.ODOTTAA_HYVAKSYNTAA
  }

  get showAcceptedByEveryone() {
    return this.koejaksoData.valiarvioinninTila === LomakeTilat.HYVAKSYTTY
  }

  get koejaksoData(): Koejakso {
    return store.getters['erikoistuva/koejakso']
  }

  setKoejaksoData() {
    if (this.koejaksoData.valiarviointi) {
      this.valiarviointiLomake = this.koejaksoData.valiarviointi
    }
  }

  naytaKehittamistoimenpideKategoria(kategoria: string) {
    if (kategoria === KehittamistoimenpideKategoria.MUU)
      return this.valiarviointiLomake?.muuKategoria
    return this.$t('kehittamistoimenpidekategoria-' + kategoria)
  }

  get sortedKategoriat() {
    return this.valiarviointiLomake?.kehittamistoimenpideKategoriat?.sort(
      (a, b) => this.kategoriaOrder.indexOf(a) - this.kategoriaOrder.indexOf(b)
    )
  }

  get hyvaksynnat(): KoejaksonVaiheHyvaksynta[] {
    const hyvaksyntaErikoistuva = hyvaksynnatHelper.mapHyvaksyntaErikoistuva(
      this,
      this.valiarviointiLomake?.erikoistuvanNimi,
      this.valiarviointiLomake?.erikoistuvanKuittausaika
    )
    const hyvaksyntaLahikouluttaja = hyvaksynnatHelper.mapHyvaksyntaLahikouluttaja(
      this,
      this.valiarviointiLomake?.lahikouluttaja
    )
    const hyvaksyntaLahiesimies = hyvaksynnatHelper.mapHyvaksyntaLahiesimies(
      this,
      this.valiarviointiLomake?.lahiesimies
    )

    return [hyvaksyntaLahikouluttaja, hyvaksyntaLahiesimies, hyvaksyntaErikoistuva].filter(
      (a): a is KoejaksonVaiheHyvaksynta => a !== null
    )
  }

  optionDisplayName(option: any) {
    return option.nimike ? option.nimi + ', ' + option.nimike : option.nimi
  }

  hideModal(id: string) {
    return this.$bvModal.hide(id)
  }

  onLahikouluttajaSelect(lahikouluttaja: KoejaksonVaiheHyvaksyja) {
    this.valiarviointiLomake.lahikouluttaja = lahikouluttaja
  }

  onLahiesimiesSelect(lahiesimies: KoejaksonVaiheHyvaksyja) {
    this.valiarviointiLomake.lahiesimies = lahiesimies
  }

  onValidateAndConfirm(modalId: string) {
    if (
      this.$refs.koulutuspaikanArvioijat &&
      !this.$refs.koulutuspaikanArvioijat.validateForm()
    ) {
      return
    }
    return this.$bvModal.show(modalId)
  }

  async onSend() {
    try {
      this.buttonStates.primaryButtonLoading = true
      await store.dispatch('erikoistuva/postValiarviointi', this.valiarviointiLomake)
      this.buttonStates.primaryButtonLoading = false
      toastSuccess(this, this.$t('valiarviointi-lahetetty-onnistuneesti'))
      this.setKoejaksoData()
    } catch (err) {
      toastFail(this, formatSaveError(this, err, this.$t('valiarviointi-tallennus-epaonnistui')))
    } finally {
      this.buttonStates.primaryButtonLoading = false
    }
  }

  async onFormDelete() {
    try {
      this.buttonStates.primaryButtonLoading = true
      await store.dispatch('erikoistuva/deleteValiarviointi', this.valiarviointiLomake)
      this.buttonStates.primaryButtonLoading = false
      toastSuccess(this, this.$t('lomake-tyhjennetty-onnistuneesti'))
      this.valiarviointiLomake.id = null
    } catch {
      toastFail(this, this.$t('lomakkeen-tyhjennys-epaonnistui'))
    }
  }

  async mounted() {
    this.loading = true
    if (!this.koejaksoData) {
      await store.dispatch('erikoistuva/getKoejakso')
    }
    await store.dispatch('erikoistuva/getKouluttajatJaVastuuhenkilot')
    this.setKoejaksoData()
    this.loading = false
  }
}
